<mat-form-field appearance="fill" fxFlexFill>
    <mat-label>Profesor</mat-label>
    <mat-select [(ngModel)]="this.teacherId" (selectionChange)="onChangeSelection()">
        <mat-option value="">- Ninguno seleccionado -</mat-option>
        <mat-option *ngFor="let teacher of teachers" [value]="teacher.id">
            {{teacher.fatherSurname + ' ' + teacher.motherSurname + ', ' + teacher.names}}
        </mat-option>
    </mat-select>
</mat-form-field>